import * as React from "react";

const SvgRcs = (props) => (
  <svg
    width="1em"
    height="1em"
    viewBox="0 0 24 24"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    fill="currentColor"
    {...props}
  >
    <defs>
      <path
        d="M4 4h16v12H5.17L4 17.17V4zm0-2c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2H4zm2.066 11v-2.191h1.102L8.308 13h1.06v-.05L8.09 10.577c.492-.207.492-.207.767-.592.276-.384.276-.384.276-.955 0-.836 0-.836-.535-1.277-.536-.441-.536-.441-1.52-.441h-2V13h.988zm1.016-2.984H6.066V8.109H7.11c.516.008.516.008.776.258s.26.25.26.707c0 .438 0 .438-.282.69-.281.252-.281.252-.781.252zm5.098 3.062c.972 0 .972 0 1.558-.51.586-.51.586-.51.672-1.42h-.984c-.078.61-.078.61-.371.872-.293.261-.293.261-.875.261-.637 0-.637 0-.967-.484-.33-.485-.33-.485-.33-1.406v-.504c.008-.91.008-.91.353-1.381.346-.47.346-.47.99-.47.555 0 .555 0 .842.27.287.272.287.272.358.885h.984c-.094-.933-.094-.933-.668-1.445-.574-.512-.574-.512-1.515-.512-.7 0-.7 0-1.233.332-.533.332-.533.332-.818.946-.285.613-.285.613-.285 1.418v.53c.011.786.011.786.293 1.38.28.594.28.594.798.916.518.322.518.322 1.198.322zm5.05 0c.934 0 .934 0 1.479-.42s.545-.42.545-1.13c0-.438 0-.438-.188-.764-.187-.326-.187-.326-.59-.578-.402-.252-.402-.252-1.066-.45-.664-.197-.664-.197-.953-.406-.289-.209-.289-.209-.289-.521 0-.371 0-.371.268-.579.267-.207.267-.207.752-.207.519 0 .519 0 .798.252.28.252.28.252.28.698h.984c0-.493 0-.493-.266-.897-.265-.404-.265-.404-.73-.623-.465-.219-.465-.219-1.059-.219-.894 0-.894 0-1.455.446-.56.445-.56.445-.56 1.133 0 .785 0 .785.777 1.273.406.254.406.254 1.094.46.687.208.687.208.951.411.264.203.264.203.264.578 0 .344 0 .344-.26.553-.26.209-.26.209-.776.209-.597 0-.597 0-.918-.266-.32-.265-.32-.265-.32-.75h-.988c0 .535 0 .535.287.938.287.402.287.402.805.63.517.23.517.23 1.134.23z"
        id="Rcs_svg__a"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path d="M0 0h24v24H0z" />
      <mask id="Rcs_svg__b" fill="#fff">
        <use xlinkHref="#Rcs_svg__a" />
      </mask>
      <use fill="#FFF" fillRule="nonzero" xlinkHref="#Rcs_svg__a" />
      <g mask="url(#Rcs_svg__b)" fill="#B3BAC5">
        <path d="M0 0h24v24H0z" />
      </g>
    </g>
  </svg>
);

export default SvgRcs;
